.row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-top: 1.5px solid var(--ink);
  color: var(--ink);
  text-decoration: none;
}

.row:first-child {
  border-top: 0;
}

.lines {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.name {
  font-size: 16px;
  font-weight: 600;
}

.detail {
  font-size: 14px;
  color: var(--ink-2);
}

.chevron {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  background-color: var(--ink-3);
  -webkit-mask: url('./chevron.svg') no-repeat center / contain;
  mask: url('./chevron.svg') no-repeat center / contain;
}

.fresh {
  flex: 0 0 auto;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--accent-soft);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
